import { h } from 'preact'
import Switcher from '../control/Switcher'
import { ActionButtons } from '../registration-rules/PanelItems'
import { InformationCallout } from '../ui-components/InformationCallout'
import InputGroup from '../ui-components/InputGroup'
import Icon from '../assets'
import { PanelHeaderWithIcon } from '../ui-components/PanelHeaderWithIcon'

interface BodyProps {
    isNotifyMarkAnswerEnabled: boolean,
    showActionButtons: boolean,
    showValidationError: boolean,
    notifyAfter?: number,
    onSave: () => void,
    onCancel: () => void,
    onInputFocus: () => void,
    onInputBlur: () => void,
    onInputChange: (value: string) => void,
    onNotifyMarkAnswerSettingChanged: (value: boolean) => void,
}

export const NotifyToMarkAnswerPanelBody = ({ isNotifyMarkAnswerEnabled, notifyAfter, showActionButtons, showValidationError, onSave, onCancel, onInputFocus, onNotifyMarkAnswerSettingChanged, onInputChange, onInputBlur } : BodyProps) => {
  const isInputEnabled = !isNotifyMarkAnswerEnabled
  return (<div className='panel-body-container panel-notify-mark-answer'>
    <div className='panel-switch-input-dropdown-container'>
      <div className='switch-icon-container'>
        <Switcher
          on={isNotifyMarkAnswerEnabled}
          customClass='panel-switch'
          labelCustomClass='panel-switch-label panel-notify-mark-answer-switch'
          label={<LabelWithInputGroupInText isInputEnabled={isInputEnabled}
            ageInDays={notifyAfter}
            onInputChange={onInputChange}
            onInputFocus={onInputFocus}
            onInputBlur={onInputBlur}
            hasError={showValidationError}
          />}
          onChange={() => onNotifyMarkAnswerSettingChanged(!isNotifyMarkAnswerEnabled)} />
      </div>
      {showValidationError &&
        <div className='error-message-container'>
          <div><Icon customClass='icon-warning' icon='warning' /></div>
          <div className='error-message'>Please fill in the required field</div>
        </div>
      }
    </div>
    <InformationCallout
      text={<div>You can customize the <a className='panel-link-text' target='_blank' href='/email/system-emails/edit?type=mark-answer-reminder'>'Is your problem solved?' email template</a> that is sent out, to match your brand.</div>} />
    {showActionButtons &&
      <ActionButtons
        onSave={() => onSave()}
        onCancel={() => onCancel()} />
    }
  </div>)
}

interface LabelWithInputProps {
    onInputChange: (value: string) => void,
    onInputFocus: () => void,
    onInputBlur: () => void,
    ageInDays?: number,
    isInputEnabled: boolean,
    hasError?: boolean
}
export const LabelWithInputGroupInText = ({ isInputEnabled, ageInDays, onInputChange, onInputFocus, hasError, onInputBlur } : LabelWithInputProps) => (
  <div className='panel-input-label panel-multi-line-input-label'>
   If a topic has one or more replies from a user other than the topic author, <br className='breakline' /> after this topic is inactive for
    <InputGroup
      type='number'
      min={1}
      required
      disabled={isInputEnabled}
      value={ageInDays}
      hasError={hasError}
      onChange={(e: ChangeEvent) => onInputChange(e.target.value)}
      onClick={() => onInputFocus()}
      onBlur={() => onInputBlur()}
      qaClasses='qa-notify-mark-answer-age-in-days-input' /> days, send the topic author the 'Is your problem solved?' email.</div>
)

export const NotifyToMarkAnswerPanelHeader = ({ statusText } : { statusText: string }) => (
  <PanelHeaderWithIcon
    customClass='panel-header-container'
    iconCustomClass='icon-panel-header'
    icon='suggestedCircleCheck'
    title='Ask end users to mark best answer via email'
    statusText={statusText} />
)
